import React from 'react';
import { cn } from '../../utils/cn.ts';
import { Icon } from './Icon.tsx';

const NativeButton = 'button';

interface ComboboxTriggerProps {
    controlName: string;
    enabled: boolean;
    fullWidth: boolean;
    id: string;
    isOpen: boolean;
    leftIcon?: string;
    selected: boolean;
    text: string;
    triggerClassName?: string;
    listboxId: string;
    onClose: () => void;
    onOpen: () => void;
    ref?: React.Ref<HTMLButtonElement>;
}

export const ComboboxTrigger: React.FC<ComboboxTriggerProps> = ({
    controlName,
    enabled,
    fullWidth,
    id,
    isOpen,
    leftIcon,
    selected,
    text,
    triggerClassName,
    listboxId,
    onClose,
    onOpen,
    ref,
}) => (
    <NativeButton
        ref={ref}
        id={id}
        type="button"
        aria-label={controlName}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-controls={isOpen ? listboxId : undefined}
        disabled={!enabled}
        onClick={isOpen ? onClose : onOpen}
        className={cn(
            'focus-ring inline-flex min-h-10 min-w-0 items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-left text-gray-900 text-sm shadow-sm transition-colors dark:border-border-dark dark:bg-surface-dark dark:text-white',
            'hover:border-gray-400 dark:hover:border-gray-600',
            !enabled && 'cursor-not-allowed bg-gray-50 opacity-60 dark:bg-gray-800',
            fullWidth ? 'w-full' : 'w-56 max-w-full',
            triggerClassName
        )}
    >
        <Icon name="search" size="sm" className="shrink-0 text-gray-400" />
        {leftIcon ? <Icon name={leftIcon} size="sm" className="shrink-0 text-gray-400" /> : null}
        <span
            className={cn(
                'min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap',
                !selected && 'text-gray-500 dark:text-gray-400'
            )}
        >
            {text}
        </span>
        <Icon
            name={isOpen ? 'expand_less' : 'expand_more'}
            size="sm"
            className="shrink-0 text-gray-500 dark:text-gray-300"
        />
    </NativeButton>
);

ComboboxTrigger.displayName = 'ComboboxTrigger';
